import { INotification } from "infrastructure/notification";
import { IValidationIssue } from "infrastructure/validation";

import { ITokenItem } from "../Messages.state";

export interface IMessagesUploadError {
  validationIssues?: IMessagesUploadValidationIssue[];
  text?: string;
}

export interface IMessagesUploadValidationIssue {
  uniqueId: string;
  messageId: string;
  tokens: ITokenItem[];
  text: string;
  validationIssue: IValidationIssue;
}

export interface IMessagesUploadState {
  uploadProcessing: boolean;
  uploadCompleted: boolean;
  error?: IMessagesUploadError;
  notifications: INotification[];
  progress: number;
}

export const getInitialMessagesUploadState = (): IMessagesUploadState => ({
  uploadProcessing: false,
  uploadCompleted: false,
  notifications: [],
  progress: 0
});
